import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Select, { components } from 'react-select';

import { StylesConfig } from 'react-select/src/styles';

import css from '../../css/common/controlMyVoiceButton.module.scss';
import { ReactComponent as ArrowDown } from '../../img/common/arrowDown.svg';
import { ReactComponent as ArrowUp } from '../../img/common/arrowUp.svg';
import { ReactComponent as Slider } from '../../img/common/slider.svg';
import { selectVoiceCall, setInputVolume, setMic } from '../../slice/voiceCallSlice';
import { MyPopup } from './myPopup';
import { MySlider } from './mySlider';

type ControlMyVoiceButtonProps = {
    height: number;
    width: number;
    color: string;
};
export const ControlMyVoiceButton: React.FC<ControlMyVoiceButtonProps> = (props) => {
    const dispatch = useDispatch();
    const { myVoice, currentMic, mics } = useSelector(selectVoiceCall);
    const micOptions = mics.map((mic) => ({ label: mic.label, value: mic.deviceId }));
    const DropdownIndicator = (props: any) => (
        <components.DropdownIndicator {...props}>
            {props.selectProps.menuIsOpen ? (
                <ArrowUp width="24" height="24" fill="#FAF8F7" role="img" aria-label="マイク一覧を閉じる" />
            ) : (
                <ArrowDown width="24" height="24" fill="#FAF8F7" role="img" aria-label="マイク一覧を開く" />
            )}
        </components.DropdownIndicator>
    );

    const style: StylesConfig = {
        singleValue: (provided) => ({
            ...provided,
            color: '#FAF8F7',
            fontWeight: 600,
            fontSize: 13,
            lineHeight: 16,
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '16px 12px',
        }),
        control: (provided, state) => ({
            ...provided,
            cursor: state.menuIsOpen ? 'auto' : 'default',
            borderRadius: state.menuIsOpen ? '8px 8px 0 0' : 8,
            borderWidth: state.menuIsOpen ? '1px 1px 0px 1px' : 1,
            borderStyle: 'solid',
            borderColor: '#595656',
            backgroundColor: '#403E3D',
            boxShadow: '0 0 0 0px',
            '&:hover': {
                borderColor: '#595656',
            },
        }),
        menuList: (provided) => ({
            ...provided,
            padding: 0,
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
            borderStyle: 'solid',
            borderWidth: '0px 1px 1px 1px',
            borderColor: '#595656',
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: '#403E3D',
            color: '#FAF8F7',
            fontWeight: 600,
            fontSize: 13,
            margin: 0,
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#595656' : '#403E3D',
            padding: '16px 12px',
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: '#595656',
            },
        }),
        indicatorSeparator: () => ({
            width: 0,
        }),
    };

    const defaultValue = {
        value: currentMic ? currentMic.deviceId : '',
        label: currentMic ? currentMic.label : '',
    };
    const controlPopup = (
        <div className={css.popup}>
            <div className={css.outputDevice}>
                <p>出力デバイス(イヤホン等)</p>
                <p>
                    出力デバイスの変更は、<span style={{ color: '#F14D38' }}>PCデバイスの設定</span>
                    より変更をお願いします
                </p>
            </div>
            <div className={css.inputDevice}>
                <p>入力デバイス(マイク)</p>
                <Select
                    styles={style}
                    value={defaultValue}
                    options={micOptions}
                    isSearchable={false}
                    components={{ DropdownIndicator }}
                    onChange={(event) => {
                        const deviceId = event?.value;
                        if (deviceId !== undefined) {
                            dispatch(setMic(deviceId));
                        }
                    }}
                />
            </div>
            <div className={css.inputSlider}>
                <p>入力通話音量（相手に聞こえる音量）</p>
                <MySlider
                    onChange={(val) => {
                        dispatch(setInputVolume(val));
                    }}
                    defaultValue={myVoice.inputVolume}
                />
            </div>
        </div>
    );

    return (
        <MyPopup
            trigger={
                <Slider
                    height={props.height}
                    width={props.width}
                    fill={props.color}
                    role="img"
                    aria-label="音量調整"
                    style={{ cursor: 'pointer' }}
                />
            }
            title="音声設定"
            content={controlPopup}
        />
    );
};
